import { useAgentBridge } from "./AgentBridge";

/**
 * Header dropdown that lists every model advertised by the server (`models`
 * WebSocket frame) plus a "Default model" option that clears the selection so
 * the server falls back to its configured default. Selection is persisted in
 * localStorage by the bridge and auto-injected into outgoing user messages.
 */
export function ModelPicker() {
  const { models, selectedModel, setSelectedModel } = useAgentBridge();

  return (
    <label className="model-picker">
      <span className="model-picker-label">Model</span>
      <select
        aria-label="Model"
        value={selectedModel}
        onChange={(e) => setSelectedModel(e.target.value)}
      >
        <option value="">Default model</option>
        {models.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
    </label>
  );
}
